import { Component } from '@angular/core';
import { MinsterCardComponent } from "../ui-components/minster-card/minster-card.component";

@Component({
  selector: 'app-what-next',
  standalone: true,
  imports: [MinsterCardComponent],
  templateUrl: './what-next.component.html',
  styleUrl: './what-next.component.css'
})
export class WhatNextComponent {

}
